import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.set";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import _classCallCheck from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module paragraph/paragraph
 */
import ParagraphCommand from './paragraphcommand';
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
/**
 * The paragraph feature for the editor.
 *
 * It introduces the `<paragraph>` element in the model which renders as a `<p>` element in the DOM and data.
 *
 * @extends module:core/plugin~Plugin
 */

var Paragraph =
/*#__PURE__*/
function (_Plugin) {
  _inherits(Paragraph, _Plugin);

  function Paragraph() {
    _classCallCheck(this, Paragraph);

    return _possibleConstructorReturn(this, _getPrototypeOf(Paragraph).apply(this, arguments));
  }

  _createClass(Paragraph, [{
    key: "init",

    /**
     * @inheritDoc
     */
    value: function init() {
      var _this = this;

      var editor = this.editor;
      var model = editor.model;
      var data = editor.data;
      editor.commands.add('paragraph', new ParagraphCommand(editor)); // Schema.

      model.schema.register('paragraph', {
        inheritAllFrom: '$block'
      });
      editor.conversion.elementToElement({
        model: 'paragraph',
        view: 'p'
      }); // Content autoparagraphing. --------------------------------------------------
      // Handles element which has not been converted by any plugin and checks if it would be converted if
      // we wrap it in a paragraph or change it to a paragraph.

      editor.conversion.for('upcast').elementToElement({
        model: function model(viewElement, modelWriter) {
          if (!Paragraph.paragraphLikeElements.has(viewElement.name)) {
            return null;
          } // Do not auto-paragraph empty elements.


          if (viewElement.isEmpty) {
            return null;
          }

          return modelWriter.createElement('paragraph');
        },
        converterPriority: 'low'
      });
      data.upcastDispatcher.on('element', function (evt, data, conversionApi) {
        // Do not try auto-paragraphing if the element was already converted.
        if (!conversionApi.consumable.test(data.viewItem, {
          name: data.viewItem.name
        })) {
          return;
        } // If the element is not paragraph-like try wrapping it in a paragraph.


        if (isParagraphable(data.viewItem, data.modelCursor, conversionApi.schema)) {
          Object.assign(data, wrapInParagraph(data.viewItem, data.modelCursor, conversionApi));
        }
      }, {
        priority: 'low'
      }); // Handles not converted text nodes and checks if would be converted if we wraps then by a paragraph.

      data.upcastDispatcher.on('text', function (evt, data, conversionApi) {
        // When node is already converted then do nothing.
        if (data.modelRange) {
          return;
        }

        if (isParagraphable(data.viewItem, data.modelCursor, conversionApi.schema)) {
          Object.assign(data, wrapInParagraph(data.viewItem, data.modelCursor, conversionApi));
        }
      }, {
        priority: 'lowest'
      }); // Empty roots autoparagraphing. -----------------------------------------------
      // Post-fixer which takes care of adding empty paragraph elements to empty roots.
      // Besides fixing content on #changesDone we also need to handle editor.data#ready event because
      // if initial data is empty or setData() wasn't even called there will be no #change fired.

      model.document.registerPostFixer(function (writer) {
        return _this._autoparagraphEmptyRoots(writer);
      });
      editor.data.on('ready', function () {
        model.enqueueChange('transparent', function (writer) {
          return _this._autoparagraphEmptyRoots(writer);
        });
      }, {
        priority: 'lowest'
      });
    }
    /**
     * Fixes all empty roots.
     *
     * @private
     * @returns {Boolean} `true` if any change has been applied, `false` otherwise.
     */

  }, {
    key: "_autoparagraphEmptyRoots",
    value: function _autoparagraphEmptyRoots(writer) {
      var model = this.editor.model;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = model.document.getRootNames()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var rootName = _step.value;
          var root = model.document.getRoot(rootName);

          if (root.isEmpty && root.rootName != '$graveyard') {
            // If paragraph element is allowed in the root, create paragraph element.
            if (model.schema.checkChild(root, 'paragraph')) {
              writer.insertElement('paragraph', root);
              return true;
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }], [{
    key: "pluginName",

    /**
     * @inheritDoc
     */
    get: function get() {
      return 'Paragraph';
    }
  }]);

  return Paragraph;
}(Plugin);
/**
 * A list of element names which should be treated by the autoparagraphing algorithms as
 * paragraph-like. This means that e.g. the following content:
 *
 *		<h1>Foo</h1>
 *		<table>
 *			<tr>
 *				<td>X</td>
 *				<td>
 *					<ul>
 *						<li>Y</li>
 *						<li>Z</li>
 *					</ul>
 *				</td>
 *			</tr>
 *		</table>
 *
 * contains five paragraph-like elements: `<h1>`, two `<td>`s and two `<li>`s.
 * Hence, if none of the features is going to convert those elements the above content will be automatically handled
 * by the paragraph feature and converted to:
 *
 *		<p>Foo</p>
 *		<p>X</p>
 *		<p>Y</p>
 *		<p>Z</p>
 *
 * Note: The `<td>` containing two `<li>` elements was ignored as the innermost paragraph-like elements
 * have a priority upon conversion.
 *
 * @member {Set.<String>} module:paragraph/paragraph~Paragraph.paragraphLikeElements
 */


export { Paragraph as default };
Paragraph.paragraphLikeElements = new Set(['blockquote', 'dd', 'div', 'dt', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'li', 'p', 'td']);

function wrapInParagraph(input, position, conversionApi) {
  var paragraph = conversionApi.writer.createElement('paragraph');
  conversionApi.writer.insert(paragraph, position);
  return conversionApi.convertItem(input, conversionApi.writer.createPositionAt(paragraph, 0));
}

function isParagraphable(node, position, schema) {
  var context = schema.createContext(position); // When paragraph is allowed in this context...

  if (!schema.checkChild(context, 'paragraph')) {
    return false;
  } // And a node would be allowed in this paragraph...


  if (!schema.checkChild(context.push('paragraph'), node)) {
    return false;
  }

  return true;
}